/* eslint-disable */
// ############ New Code ###########

import React from "react";
import PropTypes from "prop-types";
import styles from './PercentageIndicator.module.css';

const PercentageIndicatorNew = ({ percentage, activeIndex }) => {
  return (
    <div className={styles.indicator_card}>
      <div className={styles.percentage_text}>
        {percentage}
        <span className={styles.percentage_symbol}>%</span>
      </div>
      <div className={styles.indicator_dots}>
        {[1, 2,3].map((index) => (
          <div
            key={index}
            className={
              activeIndex === index
                ? styles[`dot_${index}`]
                : styles.dot
            }
          />
        ))}
      </div>
    </div>
  );
};

PercentageIndicatorNew.propTypes = {
  percentage: PropTypes.number.isRequired,
  activeIndex: PropTypes.number.isRequired,
  totalDots: PropTypes.number,
};

export default PercentageIndicatorNew;